export default [
  {
    path: '/trackers',
    name: 'trackers',
    component: () => import('@/views/Trackers'),
  },
];
